import { useMutation } from 'react-query';
import {
  updateBettieProfile,
  type UpdateBettieProfileBody,
  type UpdateBettieProfileResponse
} from '../../services/bettieService';

export function useUpdateBettieProfile() {
  return useMutation<
    UpdateBettieProfileResponse,
    Error,
    { body: UpdateBettieProfileBody; chatRoomId: string }
  >(({ body, chatRoomId }) => updateBettieProfile(body, chatRoomId));
}
